import * as React from "react";

import Icon from "./Icon";
import Clear from "./Clear";

export default class Checkbox extends React.Component {
  static defaultProps = { checked: true };

  constructor(props) {
    super(props);

    this.state = { checked: this.props.checked };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      checked: nextProps.checked
    })
  }

  handleInputChange() {
    this.setState({ checked: !this.state.checked }, () => {
      this.props.onChange && this.props.onChange(this.state.checked);
    });
  }

  render() {
    let { icon, children, classes, disable } = this.props;
    return (
      <div
        className={"checkbox " + (disable ? "disabled " : " ") + (classes ? classes : "")}
        onClick={disable ? () => {} : this.handleInputChange}
      >
        <div className="check">
          {this.state.checked && <Icon icon={icon} />}
        </div>
        {children}
        <Clear />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/CheckBox.js